'use client';

import { Container } from 'react-bootstrap';
import type { PortableTextBlock } from 'next-sanity';

import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import VideoPlayer from '@/components/videoPlayer/videoPlayer';
import type { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import './RichTextBlock.scss';

type LandingPageData = Extract<
  NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>,
  { _type: 'landingPage' }
>;

interface RichTextBlockProps {
  data: NonNullable<LandingPageData['richTextBlock']>;
}

export default function RichTextBlock({ data }: RichTextBlockProps) {
  const { headline, backgroundColor, video } = data;

  const headlineBlocks = headline as PortableTextBlock[] | undefined;
  const headingBlocks = headlineBlocks?.filter(
    (block) => block.style === 'h1' || block.style === 'h2'
  );
  const descriptionBlocks = headlineBlocks?.filter(
    (block) => block.style !== 'h1' && block.style !== 'h2'
  );

  return (
    <section
      className="rlp-rich-text-block"
      style={
        backgroundColor?.value ? { backgroundColor: backgroundColor.value } : {}
      }
    >
      <Container>
        {headingBlocks && headingBlocks.length > 0 && (
          <div className="rlp-rich-text-headline rlp-section-headline">
            <LandingPortableText value={headingBlocks} />
          </div>
        )}
        {video && (
          <div className="rlp-rich-text-video">
            <VideoPlayer
              url={video}
              width="100%"
              height="100%"
              autoplay={false}
            />
          </div>
        )}
        {descriptionBlocks && descriptionBlocks.length > 0 && (
          <div className="rlp-rich-text-headline rlp-rich-text-description">
            <LandingPortableText value={descriptionBlocks} />
          </div>
        )}
      </Container>
    </section>
  );
}
